<template>
    <medium-dialog
        v-model="dialog"
        noActivator
        title="Kesamaan soal"
        noOkButton
        cancelButton="tutup"
        scrollable
    >
        <div v-if="question" class="body-1">
            Pertanyaan: {{ question.question }}

            <div
                v-for="(similiarity, idx) in similiarities"
                :key="`${similiarity.id}-${idx}`"
                class="ml-4 mt-2"
            >
                <p>
                    <mark>
                        {{
                            similiarity.question.substring(
                                0,
                                similiarity.questionHighlightIndex
                            )
                        }}
                    </mark>

                    {{
                        similiarity.question.substring(
                            similiarity.questionHighlightIndex
                        )
                    }}
                </p>

                <div>
                    Kesamaan:
                    <b>
                        {{
                            Math.floor(
                                (similiarity.questionHighlightIndex /
                                    question.question.length) *
                                    100
                            )
                        }}%
                    </b>
                </div>

                <b>Ada di:</b>
                <template v-if="similiarity.occurences">
                    {{
                        similiarity.occurences
                            .map(
                                occurence =>
                                    `${occurence.tryout} - ${occurence.period}`
                            )
                            .join(', ')
                    }}
                </template>
                <template v-if="similiarity.localOccurence">
                    Lokal
                    {{ tryoutOfLocalSimiliarity(similiarity).tryout.title }}
                    -
                    {{ tryoutOfLocalSimiliarity(similiarity).period.title }}
                </template>
            </div>
        </div>
    </medium-dialog>
</template>

<script>
import MediumDialog from '@/components/dialog/MediumDialog'

export default {
    props: {
        tryouts: {
            type: Array,
            required: true
        }
    },

    components: {
        MediumDialog
    },

    data: () => ({
        dialog: null,
        similiarities: null,
        question: null
    }),

    computed: {
        tryoutOfLocalSimiliarity() {
            return similiarity => {
                const tryoutIdx = parseInt(similiarity.localOccurence.tryoutIdx)

                return this.tryouts[tryoutIdx]
            }
        }
    },

    methods: {
        show(question) {
            this.question = question
            this.similiarities = question.similiarities.map(similiarity => ({
                ...similiarity,
                questionHighlightIndex: this.calculateQuestionHighlightIndex(
                    similiarity
                )
            }))
            this.dialog = true
        },

        calculateQuestionHighlightIndex(similiarity) {
            let questionHighlightIndex = 0

            for (const idx in similiarity.question) {
                if (this.question.question[idx] != similiarity.question[idx]) {
                    break
                }
                questionHighlightIndex++
            }

            return questionHighlightIndex
        }
    }
}
</script>
